type OptimizelyAttr = string | number | boolean

export function resolveClient(): typeof window.optimizely | undefined {
  if (typeof window === 'undefined') return undefined
  return window.optimizely
}

/**
 * Helper to set the user context on the client.
 * Call this when the user ID or roles change.
 */

export function setOptimizelyUser(attrs?: Record<string, OptimizelyAttr | null | undefined>): void {
  const client = resolveClient()
  if (!client?.push) return
  const cleaned = Object.fromEntries(
    Object.entries(attrs ?? {}).filter(([, v]) => v != null),
  ) as Record<string, OptimizelyAttr>
  client.push({
    type: 'user',
    attributes: Object.keys(cleaned).length ? cleaned : undefined,
  })
}
